<template>
  <div class="page-container">

    <div class="top-spacer"></div>

    <div class="header-image">
      <img src="@/images/caseban.png" alt="案例头部图" class="full-width-img" />
    </div>

    <section class="industry-section">
      <div class="section-title">
        <h1>医疗行业</h1>
        <div class="title-divider"></div>
      </div>
      <div class="case-card">
        <div class="case-content">
          <span class="text-title">困境：</span>
          <p class="text-desc">
            医疗行业仓库(涵盖药品、耗材、器械、应急物资等)因产品特性(高风险性、强合规性)与场景需求(应急响应、精准追溯)，面临“合规-效率-安全”的三重矛盾。
          </p>
          <p class="text-bold">预期：效期管理问题(过期、临期错发)减少至原有的 5%，出入库转环节高效率，仓储空间利用率提升 50%。</p>
          <img src="@/images/casetip.png" alt="提示标识" class="tip-img" />
          <p class="text-bold">入库扫码建档，出车扫码核验，追溯链可视化</p>
          <p class="text-bold">出入库效率提升:</p>
          <p class="text-desc">扫码设备替代人工，流程压缩 60%</p>
          <p class="text-bold">空间利用循环率提升:</p>
          <p class="text-desc">扫码驱动动态储位管理</p>
          <p class="text-bold">设备选型与系统联动建议</p>
        </div>
        <div class="case-image">
          <img src="@/images/case01.png" alt="医疗行业案例图" class="responsive-img" />
        </div>
      </div>
    </section>

    <section class="industry-section">
      <div class="section-title">
        <h1>食品行业</h1>
        <div class="title-divider"></div>
      </div>
      <div class="case-card reverse-layout">
        <div class="case-content">
          <span class="text-title">困境：</span>
          <p class="text-desc">
            有部分短保质期产品，应季产品占收比超50%，日常销量与促销时差别大。仓内组礼盒，过季后产品报废率高。应季电商、团购，线下多渠道出库，高峰时现场混乱。
          </p>
          <p class="text-bold">预期：实现效期管理，包材可推荐</p>
          <img src="@/images/casetip.png" alt="提示标识" class="tip-img" />
          <p class="text-desc">采用工厂仓+中心发货仓</p>
          <p class="text-desc">使用拖盘高频调拨，控制库存水平</p>
          <p class="text-desc">通过工单系统严控退货与异常件</p>
          <p class="text-desc">通过WMS控制短保品的效期，多渠道调货</p>
          <p class="text-desc">解决了中秋年货等促销大季的收、发、存问题，仓序从5个优化到2个，效期问题降低到原有的5%。</p>
        </div>
        <div class="case-image">
          <img src="@/images/case02.png" alt="食品行业案例图" class="responsive-img" />
        </div>
      </div>
    </section>

    <section class="industry-section">
      <div class="section-title">
        <h1>设备行业</h1>
        <div class="title-divider"></div>
      </div>
      <div class="case-card">
        <div class="case-content">
          <span class="text-title">困境：</span>
          <p class="text-desc">
            部分产品无条码，物料编码精准到spu，无法到sku，部分产品有SN码，导致拣选和验货靠人工，错误多。
          </p>
          <p class="text-bold">预期：完成系统化仓储管理，降低错误率</p>
          <img src="@/images/casetip.png" alt="提示标识" class="tip-img" />
          <p class="text-desc">分一期与二期开发，一期平面仓，二期miniload与堆垛机密集存储</p>
          <p class="text-desc">WMS与金蝶对接，定制开发“货配单”发货功能</p>
          <p class="text-desc">使用miniload料箱密集存储，货品存放进行分级</p>
          <p class="text-desc">通过WMS对快件的物流链路进行跟踪</p>
          <p class="text-desc">解决了无条码产品出错率高的问题，存储场地减少60%，物流客诉率处理效率提升35%</p>
        </div>
        <div class="case-image">
          <img src="@/images/case03.png" alt="设备行业案例图" class="responsive-img" />
        </div>
      </div>
    </section>

    <section class="industry-section">
      <div class="section-title">
        <h1>海外行业</h1>
        <div class="title-divider"></div>
      </div>
      <div class="case-card reverse-layout">
        <div class="case-content">
          <span class="text-title">困境：</span>
          <p class="text-desc">
            无堆场管理软件，找货难，出入库单据与实际出入分离 堆场面积大，货品种类多，难管理 外籍员工占比高，稳定任差，复杂流程难以落他 场内大车与吊车多，存在相互等待的情况
          </p>
          <p class="text-bold">预期：规范仓库管理，快速找货</p>
          <img src="@/images/casetip.png" alt="提示标识" class="tip-img" />
          <p class="text-desc">上线DC-WMS(堆场专业版)，对堆场分区分库管理</p>
          <p class="text-desc">对堆场进行可视化数据管理，规划车辆路线。</p>
          <p class="text-desc">把出入库的工作，用WMS分解为小任务，下发到员工和车辆</p>
          <p class="text-desc">任务系统排序进行场内车辆调度，对单项目200台车以上的工程，适用专用的无线实时调度系统。</p>
          <p class="text-desc">综合降低工程的成本5%以上，支持黑夜施工提前6个月完成3年的项目</p>
        </div>
        <div class="case-image">
          <img src="@/images/case04.png" alt="海外行业案例图" class="responsive-img" />
        </div>
      </div>
    </section>

    <section class="industry-section">
      <div class="section-title">
        <h1>三方仓</h1>
        <div class="title-divider"></div>
      </div>
      <div class="case-card">
        <div class="case-content">
          <span class="text-title">困境：</span>
          <p class="text-desc">
            商户每月对账效率低 仓内车辆调度困难 存储库位不够用，很多货品都堆到园区空地
          </p>
          <p class="text-bold">预期：快速出准确账单 合理调度车辆 尽快启动2000㎡的电商仓</p>
          <img src="@/images/casetip.png" alt="提示标识" class="tip-img" />
          <p class="text-desc">重新规划原材料存储区，规划立体仓库</p>
          <p class="text-desc">根据DC-WMS系统的发货管理规划接货月台</p>
          <p class="text-desc">采用DC-WMS系统筹建电商仓</p>
          <p class="text-desc">规划初级版半自动发货仓</p>
        </div>
        <div class="case-image">
          <img src="@/images/case05.png" alt="三方仓案例图" class="responsive-img" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IndustryCases'
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-container {
  width: 100%;
  min-width: 320px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background-color: #f7f7f7;
  padding-bottom: 60px;
}


.top-spacer {
  height: 80px;
  width: 100%;
}

.header-image {
  width: 100%;
  overflow: hidden;
}

.full-width-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.section-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 50px 0 30px;
  padding: 0 20px;
}

.section-title h1 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 15px;
  position: relative;
}

.title-divider {
  background-color: #333;
  width: 50px;
  height: 6px;
  border-radius: 3px;
}


.industry-section {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.case-card {
  display: flex;
  background-color: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 40px;
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}


.case-content, .case-image {
  width: 50%;
  padding: 30px;
  display: flex;
  flex-direction: column;
}

.case-image {
  padding: 0;
  overflow: hidden;
  background-color: #f9f9f9;
}

.responsive-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.case-image:hover .responsive-img {
  transform: scale(1.03);
}


.text-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  display: inline-block;
}

.text-desc {
  font-size: 1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.text-bold {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
}

.tip-img {
  height: 30px;
  width: 100px;
  margin: 10px 0 20px;
  object-fit: contain;
}

.reverse-layout {
  flex-direction: row-reverse;
}


@media (max-width: 768px) {
  .top-spacer {
    height: 40px;
  }

  .section-title {
    margin: 30px 0 20px;
  }

  .section-title h1 {
    font-size: 1.8rem;
  }

  .case-card {
    flex-direction: column;
  }

  .case-content, .case-image {
    width: 100%;
  }

  .case-image {
    height: 260px;
  }

  .case-content {
    padding: 25px 20px;
  }

  .text-title {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }

  .text-desc, .text-bold {
    font-size: 0.95rem;
    line-height: 1.7;
    margin-bottom: 12px;
  }

  .case-card {
    margin-bottom: 30px;
    border-radius: 8px;
  }
}


@media (min-width: 769px) and (max-width: 1024px) {
  .case-content, .case-image {
    padding: 25px;
  }

  .text-title {
    font-size: 1.3rem;
  }

  .text-desc, .text-bold {
    font-size: 0.95rem;
    line-height: 1.7;
  }
}
</style>